var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useEffect, useState } from 'react';
import OtoDropdown from 'Comps/common/OtoDropdown';
import AddressAutocomplete from 'Comps/OrderForm/AddressAutocomplete';
import DeliveryService, { geocodeByAddress, } from '../../utils/location';
import { DELIVERY_MODES } from 'App/config';
import { isLUBJE } from 'App/services/tenant';
var HomePageOrderSelectBar = function () {
    var deliveryPrefs = {};
    var _a = __read(useState(DELIVERY_MODES[0].name), 2), deliveryMode = _a[0], setDeliveryMode = _a[1];
    var _b = __read(useState(''), 2), address = _b[0], setAddress = _b[1];
    var isNotTakeout = deliveryMode === DELIVERY_MODES[0].name;
    useEffect(function () {
        deliveryPrefs = DeliveryService.getDeliveryPreferences() || {};
        setDeliveryMode(deliveryPrefs.mode || DELIVERY_MODES[0].name);
        setAddress(deliveryPrefs.address || '');
    }, []);
    var handleAddressSelect = React.useCallback(function (newAddress) {
        geocodeByAddress(newAddress)
            .then(function (googleMapPlace) {
            setAddress(newAddress);
            var newDeliveryPrefs = DeliveryService.mapGooglePlaceToDeliveryPrefs(googleMapPlace, newAddress, deliveryMode);
            DeliveryService.saveDeliveryPreferences(newDeliveryPrefs, 'home page 1');
        })
            .catch(function (error) { return console.error('Error', error); });
    }, []);
    var handleDeliveryModeChange = useCallback(function (newDeliveryMode) {
        setDeliveryMode(newDeliveryMode);
        DeliveryService.saveDeliveryPreferences({
            address: address,
            mode: newDeliveryMode,
        }, 'home page 2');
    }, []);
    var handleButtonClick = function () {
        window.location.href = "/zamawiaj?delivery=".concat(deliveryMode);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "d-flex flex-column flex-nowrap flex-md-row justify-content-between" },
            React.createElement("div", { className: "oto-control-wrapper" },
                React.createElement(OtoDropdown, { icon: "car.svg", label: "Spos\u00F3b odbioru", options: DELIVERY_MODES, onChange: handleDeliveryModeChange, value: deliveryMode }),
                isNotTakeout && (React.createElement(AddressAutocomplete, { className: "oto-control oto-control--input", inputClassName: "oto-control__input", handleValueChange: setAddress, handleSelect: handleAddressSelect, placeholder: "Adres - ulica, nr budynku, miasto", value: address },
                    React.createElement("button", { type: "button", "aria-label": "Usu\u0144 wprowadzony adres", className: "oto-control__clear-btn ".concat(isLUBJE() && 'oto-control__clear-btn--lubje'), onClick: function () { return setAddress(''); } }, "+")))),
            React.createElement("button", { type: "button", className: "home-switch-btn ml-md-2 ".concat(isLUBJE() ? 'home-switch-btn--lubje' : 'mx-auto'), onClick: handleButtonClick }, "Poka\u017C restauracje"))));
};
export default HomePageOrderSelectBar;
